export default __webpack_public_path__ + "static/media/Q6_2.29cbd02a.png";